import { render, staticRenderFns } from "./QuizButton.vue?vue&type=template&id=61bf5821&scoped=true&"
import script from "./QuizButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./QuizButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./QuizButton.vue?vue&type=style&index=0&id=61bf5821&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bf5821",
  null
  
)

export default component.exports